import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, Teleport as _Teleport, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, unref as _unref, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, renderList as _renderList } from "vue"

const _hoisted_1 = { class: "flex-grow bg-[#f5f5f5]" }
const _hoisted_2 = { class: "container mx-auto px-4 pt-6 pb-14 sm:px-6 lg:px-8" }
const _hoisted_3 = { class: "flex flex-row flex-wrap justify-between mt-8 mb-6 gap-3 md:items-center" }
const _hoisted_4 = { class: "w-full lg:w-auto" }
const _hoisted_5 = { class: "text-3xl tracking-tight font-medium text-gray-900" }
const _hoisted_6 = { class: "grid grid-cols-1 gap-6 md:grid-cols-2 xl:grid-cols-3 clear-both" }
const _hoisted_7 = { class: "mb-6 col-span-2" }
const _hoisted_8 = { class: "prose" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("p", null, "Their responses are grouped, so you can easily see which DNS servers are returning the same records.", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_12 = { class: "grid grid-cols-1 gap-6 md:grid-cols-2 xl:grid-cols-3 clear-both" }
const _hoisted_13 = { class: "px-4 py-5 sm:px-6 bg-gray-50" }
const _hoisted_14 = { class: "-ml-4 -mt-4 flex flex-wrap items-center justify-between sm:flex-nowrap" }
const _hoisted_15 = { class: "ml-4 mt-4" }
const _hoisted_16 = { class: "flex items-center space-x-3" }
const _hoisted_17 = { class: "text-lg font-medium leading-6 text-gray-900" }
const _hoisted_18 = {
  key: 0,
  class: "inline-block flex-shrink-0 rounded-full bg-green-100 ml-2 px-2 py-0.5 text-xs font-medium text-green-800"
}
const _hoisted_19 = { class: "mt-1 text-sm text-gray-500" }
const _hoisted_20 = { class: "ml-4 mt-4 flex-shrink-0" }
const _hoisted_21 = { class: "flex -space-x-2" }
const _hoisted_22 = ["src", "alt", "title"]
const _hoisted_23 = { class: "inline-flex h-8 w-8 items-center justify-center rounded-full bg-gray-500" }
const _hoisted_24 = { class: "text-sm font-medium leading-none text-white" }
const _hoisted_25 = ["src", "alt", "title"]
const _hoisted_26 = {
  key: 0,
  class: "flex-grow font-mono overflow-x-auto px-4 py-5 sm:px-6"
}
const _hoisted_27 = {
  key: 1,
  class: "flex-grow px-4 py-5 sm:px-6"
}
const _hoisted_28 = { class: "grid grid-cols-1 gap-6 lg:grid-cols-2 xl:grid-cols-3" }
const _hoisted_29 = { class: "col-span-1" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("h2", { class: "pt-12 text-xl font-semibold text-gray-900" }, "Authoritative DNS servers", -1)
const _hoisted_31 = { class: "mt-2 pb-3 text-sm text-gray-700" }
const _hoisted_32 = { class: "col-span-1" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("h2", { class: "pt-12 text-xl font-semibold text-gray-900" }, "Global DNS networks", -1)
const _hoisted_34 = { class: "mt-2 pb-3 text-sm text-gray-700" }
const _hoisted_35 = { class: "col-span-1 lg:col-span-2 xl:col-span-1" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("h2", { class: "pt-12 text-xl font-semibold text-gray-900" }, "Regional DNS servers", -1)
const _hoisted_37 = /*#__PURE__*/_createElementVNode("p", { class: "mt-2 pb-3 text-sm text-gray-700" }, "These servers may cache DNS records.", -1)

import { computed, ref, watch } from 'vue';
import router from '@/router';
import {
  addResponse, getVariant, getVariantName, Variant,
} from '@/common/propagationVariant';
import {
  flagIconSrc, organizationIconSrc, displayHostingEntity, iconSrc, iconAlt,
} from '@/common/hostingEntity';
import MetaTags from '@/components/MetaTags.vue';
import FooterComponent from '@/components/layout/FooterComponent.vue';
import HeaderComponent from '@/components/layout/HeaderComponent.vue';
import RecordTypePicker from '@/components/RecordTypePicker.vue';
import PropagationServerList, { PropagationServerListItem } from '@/components/dns-propagation/PropagationServerList.vue';
import {
  DnsPropagationAnswer, DnsPropagationResult, GlobalQueryTarget, isGlobalQueryTarget, RegionalQueryTarget,
} from '@/model/PropagationEndpoint';
import PropagationMap from '@/components/dns-propagation/PropagationMap.vue';
import AlertComponent from '@/components/micro/AlertComponent.vue';
import DurationComponent from '@/components/micro/DurationComponent.vue';
import { DnsServer } from '@/model/Api';
import AdUnit from '@/components/ads/AdUnit.vue';
import {
  Billboard, LargeLeaderboard, LargeRectangle, Leaderboard, MediumRectangle,
} from '@/common/adSizes';
import { PropagationTop, PropagationMid, PropagationBottom } from '@/common/adSlots';


export default /*#__PURE__*/_defineComponent({
  __name: 'DnsPropagationResults',
  props: {
  routerDomain: {
    type: String,
    required: true,
  },
  routerRecordType: {
    type: String,
    required: true,
  },
},
  setup(__props) {

const props = __props;



const organizationList: Array<GlobalQueryTarget> = ['CloudFlare', 'Google', 'Quad9', 'OpenDns', 'CleanBrowsing', 'AdGuard', 'NextDNS', 'ControlDUnfiltered', 'UltimateHostsBlacklist'];
const countryList: Array<RegionalQueryTarget> = ['SouthAfrica', 'TheNetherlands', 'Australia', 'India', 'USA', 'Brazil', 'Ukraine', 'Russia', 'Canada'];

const domain = ref('');
const domainPunycode = ref('');
const loading = ref(true);

const recordType = ref(props.routerRecordType.toUpperCase());

const globalResponses = ref<Map<GlobalQueryTarget, DnsPropagationAnswer>>(new Map());
const regionalResponses = ref<Map<RegionalQueryTarget, DnsPropagationAnswer>>(new Map());
const authoritativeResponses = ref<Map<DnsServer, DnsPropagationAnswer>>(new Map());
const variants = ref<Array<Variant>>([]);

const formattedQueryLocation = computed(() => {
  const location = [...globalResponses.value.values(), ...regionalResponses.value.values(), ...authoritativeResponses.value.values()][0]?.queryLocation;
  if (location === undefined) {
    return undefined;
  }
  if (location === 'Amsterdam') {
    return 'Amsterdam, the Netherlands';
  }
  return 'San Fransisco, USA';
});
const authoritativeServersDisagree = computed(() => variants.value.filter((variant) => variant.isAuthoritative).length > 1);
const maxTtl = computed(() => Math.max(...variants.value.filter((variant) => !variant.isAuthoritative).flatMap((variant) => variant.records.map((rr) => rr.ttl))));
const markers = computed(() => [...regionalResponses.value.values()].flatMap((response) => {
  if (response.server.location) {
    return [{
      lat: response.server.location.lat,
      lon: response.server.location.lon,
      variant: variants.value.length === 1 || getVariant(variants.value, response),
    }];
  }
  return [];
}));

function load() {
  loading.value = true;
  globalResponses.value = new Map();
  regionalResponses.value = new Map();
  authoritativeResponses.value = new Map();
  variants.value = [];

  const connection = new WebSocket(`${window.location.origin.replace(/^http/, 'ws')}/api/v1/ws/dns-propagation`);

  connection.onmessage = (event) => {
    const response: DnsPropagationResult = JSON.parse(event.data);
    if ('Left' in response) {
      console.error(response.Left);
    } else {
      const answer = response.Right;
      if (answer.queryTarget === 'Authoritative') {
        authoritativeResponses.value.set(answer.server, answer);
      } else if (isGlobalQueryTarget(answer.queryTarget)) {
        globalResponses.value.set(answer.queryTarget, answer);
      } else {
        regionalResponses.value.set(answer.queryTarget, answer);
      }
      variants.value = addResponse(variants.value, answer, recordType.value);
    }
  };

  connection.onopen = () => {
    connection.send(JSON.stringify({ domain: props.routerDomain, recordType: props.routerRecordType }));
  };

  connection.onclose = () => {
    loading.value = false;
  };
}

function getGlobalResponse(qt: GlobalQueryTarget): PropagationServerListItem {
  const response = globalResponses.value.get(qt);
  if (response) {
    return {
      firstLine: displayHostingEntity(qt),
      secondLine: response.server.ip || '',
      ttl: Math.max(...response.answer.map((rr) => rr.ttl)),
      variant: variants.value.length === 1 || getVariant(variants.value, response),
      iconSrc: iconSrc(response),
      iconAlt: iconAlt(response),
      iconShape: 'circle',
    };
  }
  return {
    firstLine: displayHostingEntity(qt),
    secondLine: loading.value ? 'loading' : 'DNS server did not reply',
    ttl: null,
    variant: null,
    iconSrc: organizationIconSrc(qt),
    iconAlt: displayHostingEntity(qt),
    iconShape: 'circle',
  };
}

function getCountryResponse(qt: RegionalQueryTarget): PropagationServerListItem {
  const response = regionalResponses.value.get(qt);
  if (response) {
    return {
      firstLine: displayHostingEntity(qt),
      secondLine: response.server.ip || '',
      ttl: Math.max(...response.answer.map((rr) => rr.ttl)),
      variant: variants.value.length === 1 || getVariant(variants.value, response),
      iconSrc: flagIconSrc(qt),
      iconAlt: iconAlt(response),
      iconShape: '4x3',
    };
  }
  return {
    firstLine: displayHostingEntity(qt),
    secondLine: loading.value ? 'Loading...' : 'DNS server did not reply.',
    ttl: null,
    variant: null,
    iconSrc: flagIconSrc(qt),
    iconAlt: displayHostingEntity(qt),
    iconShape: '4x3',
  };
}

function getAuthoritativeResponses(): PropagationServerListItem[] {
  function sortFn(l: PropagationServerListItem, r: PropagationServerListItem) {
    if (l.firstLine > r.firstLine) {
      return 1;
    }
    if (l.firstLine < r.firstLine) {
      return -1;
    }
    return 0;
  }
  return Array.from(authoritativeResponses.value).map(([server, answer]) => ({
    firstLine: server.domain || '',
    secondLine: server.ip || '',
    ttl: Math.max(...answer.answer.map((rr) => rr.ttl)),
    variant: variants.value.length === 1 || getVariant(variants.value, answer),
    iconSrc: iconSrc(answer),
    iconAlt: iconAlt(answer),
    iconShape: 'circle' as const,
  })).sort(sortFn);
}

watch(() => recordType.value, () => {
  router.push(`/domains/${domainPunycode.value}/dns-propagation/${recordType.value.toLowerCase()}/`);
});

watch(() => props.routerDomain, () => {
  if (domainPunycode.value !== props.routerDomain) {
    domain.value = decodeURI(props.routerDomain)
      .toLowerCase();
    domainPunycode.value = decodeURI(props.routerDomain)
      .toLowerCase();
    load();
  }
}, {
  immediate: true,
});

watch(() => props.routerRecordType, () => {
  recordType.value = props.routerRecordType.toUpperCase();
  load();
});


return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_openBlock(), _createBlock(_Teleport, { to: "head" }, [
      _createVNode(MetaTags, {
        title: `DNS propagation for ${domain.value}`,
        description: `${domain.value}'s global DNS propagation shown on a map. Shows authoritative responses, global DNS servers, local DNS servers, and more.`,
        url: `https://www.nslookup.io/domains/${domainPunycode.value}/dns-propagation/${recordType.value.toLowerCase()}/`
      }, null, 8, ["title", "description", "url"])
    ])),
    _createVNode(HeaderComponent, {
      domain: domain.value,
      "domain-search-to-url": (encodedDomain) => `/domains/${encodedDomain}/dns-propagation/${recordType.value.toLowerCase()}/`,
      "search-button-text": "Check propagation"
    }, null, 8, ["domain", "domain-search-to-url"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("main", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("h1", _hoisted_5, "DNS propagation for " + _toDisplayString(domain.value === domainPunycode.value ? domain.value : `${domainPunycode.value} (${domain.value})`), 1),
            _createVNode(_component_router_link, {
              to: `/domains/${domainPunycode.value}/dns-records/`,
              class: "underline text-sm font-medium text-blue-600"
            }, {
              default: _withCtx(() => [
                _createTextVNode("All DNS records")
              ]),
              _: 1
            }, 8, ["to"])
          ]),
          _createVNode(RecordTypePicker, {
            modelValue: recordType.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((recordType).value = $event))
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createVNode(AdUnit, {
              class: "float-right ml-6 shadow rounded-lg overflow-hidden",
              config: _unref(PropagationTop)
            }, null, 8, ["config"]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("p", null, "We've queried 9 regional DNS servers, 9 global DNS networks, and " + _toDisplayString(authoritativeResponses.value.size) + " authoritative DNS servers for " + _toDisplayString(domainPunycode.value) + "'s " + _toDisplayString(recordType.value) + " records.", 1),
              _hoisted_9,
              (!loading.value && variants.value.length > 0)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    (variants.value.length === 1)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          (variants.value[0].records.length === 0)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                (recordType.value === 'NS')
                                  ? (_openBlock(), _createBlock(AlertComponent, {
                                      key: 0,
                                      type: "warning",
                                      class: "flex not-prose shadow-sm",
                                      "has-border": true
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode("None of the servers returned any NS records."),
                                        _hoisted_10,
                                        _createTextVNode("This means that the domain name has not been "),
                                        _createVNode(_component_router_link, {
                                          to: "/learning/zone-delegation/",
                                          class: "font-medium underline underline-offset-2"
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode("delegated")
                                          ]),
                                          _: 1
                                        }),
                                        _createTextVNode(". If this domain was recently registered, then the "),
                                        _createVNode(_component_router_link, {
                                          to: "/learning/how-does-domain-name-registration-work/#the-registry",
                                          class: "font-medium underline underline-offset-2"
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode("registry")
                                          ]),
                                          _: 1
                                        }),
                                        _createTextVNode(" likely hasn't updated their DNS records yet.")
                                      ]),
                                      _: 1
                                    }))
                                  : (_openBlock(), _createBlock(AlertComponent, {
                                      key: 1,
                                      type: "info",
                                      class: "flex not-prose shadow-sm",
                                      "has-border": true
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode("None of the servers returned any records."),
                                        _hoisted_11,
                                        _createTextVNode("If this is not what you were expecting, then "),
                                        _createVNode(_component_router_link, {
                                          to: `/domains/${domainPunycode.value}/dns-propagation/ns/`,
                                          class: "font-medium underline underline-offset-2"
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode("check the NS records")
                                          ]),
                                          _: 1
                                        }, 8, ["to"]),
                                        _createTextVNode(" for this domain to see if they have propagated.")
                                      ]),
                                      _: 1
                                    }))
                              ], 64))
                            : (_openBlock(), _createBlock(AlertComponent, {
                                key: 1,
                                type: "success",
                                class: "flex not-prose shadow-sm",
                                "has-border": true
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode("All servers returned the same record set. This means that the DNS records have fully propagated.")
                                ]),
                                _: 1
                              }))
                        ], 64))
                      : (['A', 'AAAA'].includes(recordType.value))
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            (variants.value.length > 2)
                              ? (_openBlock(), _createBlock(AlertComponent, {
                                  key: 0,
                                  type: "info",
                                  class: "flex not-prose shadow-sm",
                                  "has-border": true
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("There are more than two variants. The authoritative servers likely return different record sets in order to spread the load among multiple webservers.")
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true)
                          ], 64))
                        : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                            (_unref(authoritativeServersDisagree))
                              ? (_openBlock(), _createBlock(AlertComponent, {
                                  key: 0,
                                  type: "warning",
                                  class: "flex not-prose shadow-sm",
                                  "has-border": true
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("The authoritative DNS servers returned different record sets. This indicates an issue in " + _toDisplayString(domain.value) + "'s DNS configuration.", 1)
                                  ]),
                                  _: 1
                                }))
                              : (_openBlock(), _createBlock(AlertComponent, {
                                  key: 1,
                                  type: "warning",
                                  class: "flex not-prose shadow-sm",
                                  "has-border": true
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(domain.value) + "'s DNS records have not yet fully propagated.", 1),
                                    (_unref(maxTtl))
                                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                          _createTextVNode(" Based on the response TTLs, this will likely persist for another "),
                                          _createVNode(DurationComponent, { seconds: _unref(maxTtl) }, null, 8, ["seconds"]),
                                          _createTextVNode(".")
                                        ], 64))
                                      : _createCommentVNode("", true)
                                  ]),
                                  _: 1
                                }))
                          ], 64))
                  ], 64))
                : _createCommentVNode("", true)
            ])
          ]),
          _createVNode(PropagationMap, {
            markers: _unref(markers),
            class: "rounded-lg shadow overflow-hidden"
          }, null, 8, ["markers"])
        ]),
        _createElementVNode("ul", _hoisted_12, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(variants.value, (variant, index) => {
            return (_openBlock(), _createElementBlock("li", {
              key: index,
              class: "flex flex-col col-span-1 divide-y divide-gray-200 rounded-lg bg-white shadow overflow-hidden ring-1 ring-black ring-opacity-5"
            }, [
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("div", _hoisted_16, [
                      _createElementVNode("h3", _hoisted_17, _toDisplayString(variants.value.length === 1 ? 'DNS records' : `Variant ${_unref(getVariantName)(index)}`), 1),
                      (variant.isAuthoritative)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_18, "Authoritative"))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("p", _hoisted_19, "Served by " + _toDisplayString(variants.value.length == 1 ? 'all ' : '') + _toDisplayString(variant.answers.length == 1 ? '1 server' : `${variant.answers.length} servers`) + ".", 1)
                  ]),
                  _createElementVNode("div", _hoisted_20, [
                    _createElementVNode("div", _hoisted_21, [
                      (variant.answers.length > 5)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(variant.answers.slice(0, 4), (answer, index) => {
                              return (_openBlock(), _createElementBlock("img", {
                                key: index,
                                class: "inline-block h-8 w-8 rounded-full ring-2 ring-white",
                                src: _unref(iconSrc)(answer),
                                alt: _unref(iconAlt)(answer),
                                title: _unref(iconAlt)(answer)
                              }, null, 8, _hoisted_22))
                            }), 128)),
                            _createElementVNode("span", _hoisted_23, [
                              _createElementVNode("span", _hoisted_24, "+" + _toDisplayString(variant.answers.length - 4), 1)
                            ])
                          ], 64))
                        : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(variant.answers, (answer, index) => {
                            return (_openBlock(), _createElementBlock("img", {
                              key: index,
                              class: "inline-block h-8 w-8 rounded-full ring-2 ring-white",
                              src: _unref(iconSrc)(answer),
                              alt: _unref(iconAlt)(answer),
                              title: _unref(iconAlt)(answer)
                            }, null, 8, _hoisted_25))
                          }), 128))
                    ])
                  ])
                ])
              ]),
              (variant.records.length)
                ? (_openBlock(), _createElementBlock("pre", _hoisted_26, _toDisplayString(variant.records.map((rr) => rr.raw).join('\n')), 1))
                : (_openBlock(), _createElementBlock("div", _hoisted_27, "No " + _toDisplayString(recordType.value) + " records found", 1))
            ]))
          }), 128))
        ]),
        _createVNode(AdUnit, {
          class: "mt-8 mx-auto",
          config: _unref(PropagationMid)
        }, null, 8, ["config"]),
        _createElementVNode("div", _hoisted_28, [
          _createElementVNode("div", _hoisted_29, [
            _hoisted_30,
            _createElementVNode("p", _hoisted_31, _toDisplayString(_unref(formattedQueryLocation) ? `Queried from ${_unref(formattedQueryLocation)}` : ' '), 1),
            _createVNode(PropagationServerList, {
              items: getAuthoritativeResponses()
            }, null, 8, ["items"])
          ]),
          _createElementVNode("div", _hoisted_32, [
            _hoisted_33,
            _createElementVNode("p", _hoisted_34, _toDisplayString(_unref(formattedQueryLocation) ? `Queried from ${_unref(formattedQueryLocation)}` : ' '), 1),
            _createVNode(PropagationServerList, {
              items: organizationList.map((queryTarget) => getGlobalResponse(queryTarget))
            }, null, 8, ["items"])
          ]),
          _createElementVNode("div", _hoisted_35, [
            _hoisted_36,
            _hoisted_37,
            _createVNode(PropagationServerList, {
              class: "min-w-full",
              items: countryList.map((queryTarget) => getCountryResponse(queryTarget))
            }, null, 8, ["items"])
          ])
        ]),
        _createVNode(AdUnit, {
          class: "mt-8 mx-auto",
          config: _unref(PropagationBottom)
        }, null, 8, ["config"])
      ])
    ]),
    _createVNode(FooterComponent)
  ], 64))
}
}

})